import request from "@/utils/request";

import { orderDetailsItem } from "@/props/IProduct";
import { IVoucherQuery } from "@/props/IVoucher";
/**
 * 每天新获优惠卷列表
 * @param {*} params
 * @returns
 */
export function dailyListApi(params: { page?: number; size?: number }) {
  return request({
    url: "/front/voucher/dailyAcquired",
    method: "GET",
    params,
  });
}
/**
 * @description 以状态获取优惠卷列表接口
 * @date 25/03/2025
 * @export
 * @param {{page?:number,limit?:number}} params
 * @return {*}
 */
export function getByStatusApi(params: IVoucherQuery) {
  return request({
    url: "/front/voucher/getByStatus",
    method: "GET",
    params,
  });
}
/**
 * @description 获取新优惠卷接口
 * @date 25/03/2025
 * @export
 * @return {*}
 */
export function acquireNewApi() {
  return request({
    url: "/front/voucher/acquireNew",
    method: "POST",
  });
}

/**
 * @description 获取最优优惠接口
 * @date 25/03/2025
 * @export
 * @param {*} data
 * @return {*}
 */
export function getOptimalApi(data: {
  preOrderType: "shoppingCart";
  orderDetails: orderDetailsItem[];
}) {
  return request({
    url: "/front/voucher/optimal",
    method: "POST",
    data,
  });
}

/**
 * @description 选取可使用的优惠卷接口
 * @date 25/03/2025
 * @export
 * @param {*} data
 * @return {*}
 */
export function selectVoucherApi(params: { voucherId: number,preOrderId:string }) {
  return request({
    url: "/front/voucher/selectVoucher",
    method: "GET",
    params,
  });
}

/**
 * @description  给予优惠卷接口
 * @date 25/03/2025
 * @export
 * @param {*} data
 * @return {*}
 */
export function assignVoucherApi(data: { voucherId: number }) {
  return request({
    url: "/front/voucher/assignVoucher",
    method: "POST",
    data,
  });
}

/**
 * @description 建立SSE和读取最新发布优惠卷
 * @date 25/03/2025
 * @export
 * @return {*}
 */
export function sseVoucherEventsApi() {
  return request({
    url: "/front/sseUserVoucher/events",
    method: "GET",
  });
}
/**
 * @description 获取可选择的优惠券列表
 * @date 27/03/2025
 * @export
 * @return {*}  
 */
export function getUsableVoucher(params:{preOrderId:string}) {
  return request({
    url: "/front/voucher/getUsableVoucher",
    method: "GET",
    params
  });
}
